module.exports = __webpack_public_path__ + "static/places-3e73f9c360df1c7ba71ddf0508bc4328.png";